import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from 'yup';
import { BankIDInputMeta, CorporateNameInputMeta } from "../commonMeta";

export interface IPersonalizationSettingsFormMeta {
  bankID: FormInputMeta,
  corporateName: FormInputMeta,
  agencePrepaid: FormInputMeta,
  targetAudience: FormInputMeta,
  anonymousStatus: FormInputMeta,
  agenceChargeResolving: FormInputMeta,
  typeOfNetworkCard: FormInputMeta,
  schema: any,
}

const personalizationSettingsFormMeta: IPersonalizationSettingsFormMeta = {} as IPersonalizationSettingsFormMeta;

personalizationSettingsFormMeta.bankID = BankIDInputMeta;

personalizationSettingsFormMeta.corporateName = CorporateNameInputMeta;

personalizationSettingsFormMeta.agencePrepaid = {
  label: "Agence",
  name: "agencePrepaid",
  type: 'checkbox',
  validation: yup.string(),
};

personalizationSettingsFormMeta.targetAudience = {
  label: "Target Audience",
  name: "targetAudience",
  type: 'checkbox',
};

personalizationSettingsFormMeta.anonymousStatus = {
  label: "Anonymous Status",
  name: "anonymousStatus",
  type: 'checkbox',
};

personalizationSettingsFormMeta.agenceChargeResolving = {
  label: "Agence",
  name: "agenceChargeResolving",
  type: 'checkbox',
};

personalizationSettingsFormMeta.typeOfNetworkCard = {
  label: "Type of Network Card",
  name: "typeOfNetworkCard",
  type: 'checkbox',
};

personalizationSettingsFormMeta.schema = yup.object().shape(getValidationSchema(personalizationSettingsFormMeta));

export default personalizationSettingsFormMeta;
